export default "__VITE_ASSET__8QPX6yoD__"